import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_837qgt5t4j: FaireBrandEntity = {
  token: "b_837qgt5t4j",
  type: "brand",
  name: "Funteze",
  avatarUrl:
    "https://cdn.faire.com/fastly/0ae3dcd332ff2f9b89debce9c89d228b5d6630f5c2590d555ef6a10065e42b13.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/cc25ae32be497b019eba509382fa449720f4c2042e3e82388490d1687830a8a6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0ae3dcd332ff2f9b89debce9c89d228b5d6630f5c2590d555ef6a10065e42b13.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/cc25ae32be497b019eba509382fa449720f4c2042e3e82388490d1687830a8a6.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 60,
  rating: 4.9,
  reviewCount: 501,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a fashion jewelry & accessory wholesaler offering many innovative items you simply would not find from your typical vendors. Our merchandising department is constantly on the lookout for the hottest gear and continually adding products to our database daily to offer our customers at the lowest price. ",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:59:19.189Z",
    importedBy: "entity-db-cli",
  },
};
